import { render, staticRenderFns } from "./SelectTicketMethodScreen.vue?vue&type=template&id=a4bb7288&scoped=true&"
import script from "./SelectTicketMethodScreen.vue?vue&type=script&lang=js&"
export * from "./SelectTicketMethodScreen.vue?vue&type=script&lang=js&"
import style0 from "./SelectTicketMethodScreen.vue?vue&type=style&index=0&id=a4bb7288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bb7288",
  null
  
)

export default component.exports